/**
 * Darkens a hex colour by multiplying each channel by `factor` (0=black, 1=original).
 * @param {string} hex  e.g. "#e5791b"
 * @param {number} factor  0–1
 * @returns {string} "rgb(r,g,b)"
 */
export const darkenHex = (hex, factor) => {
  const num = parseInt((hex || "#000000").replace("#", ""), 16);
  const r = Math.floor(((num >> 16) & 255) * factor);
  const g = Math.floor(((num >> 8) & 255) * factor);
  const b = Math.floor((num & 255) * factor);
  return `rgb(${r},${g},${b})`;
};

/**
 * Converts a hex colour to rgba.
 * @param {string} hex  e.g. "#e5791b"
 * @param {number} alpha  0–1
 * @returns {string} "rgba(r,g,b,alpha)"
 */
export const hexToRgba = (hex, alpha) => {
  const num = parseInt((hex || "#000000").replace("#", ""), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha})`;
};
